import { FormikValues } from 'formik';
import { useEffect, useCallback } from 'react';
import { useAlert, useNavigate, handleMutation } from '@gv/triage-components';

import { useAppSelector } from 'store';
import { useHospitalParams } from 'hooks';
import {
  selectClient,
  useDetailsQuery,
  useUpdateMutation,
} from 'store/api/clients';

import { Form } from './form';
import { EditClientFormPage } from './types';
import { getInitialValues, getUpdatePayload } from './config';

export const EditGlobal = ({
  clientId,
  hospitalId,
  ...props
}: EditClientFormPage) => {
  const navigate = useNavigate();
  const { showErrorAlert } = useAlert();
  const { isFetching } = useDetailsQuery({ id: clientId! });

  const [update, mutation] = useUpdateMutation();
  const data = useAppSelector(selectClient(clientId));

  const onSuccess = useCallback(() => navigate(-1), []);

  const onSubmit = async (values: FormikValues) => {
    const response: any = await update(getUpdatePayload(values, clientId!));
    if (response?.data?.message_alert && response?.data?.message_alert !== '') {
      showErrorAlert(response?.data?.message_alert);
    }
  };

  useEffect(() => {
    if (!isFetching && !data) {
      navigate(-2);
    }
  }, [data, isFetching, navigate]);

  handleMutation({ ...mutation, onSuccess });

  return (
    <Form
      isEdit
      clientId={clientId}
      onSubmit={onSubmit}
      hospitalId={hospitalId}
      initialValues={getInitialValues(data!)}
      {...props}
    />
  );
};

export const Edit = () => {
  const { id, clientId } = useHospitalParams();
  return <EditGlobal hospitalId={id} clientId={clientId} />;
};
